var $e73bf42412feb220$exports = {};
const { algoliasearch: $e73bf42412feb220$var$algoliasearch, instantsearch: $e73bf42412feb220$var$instantsearch } = window;
const $e73bf42412feb220$var$searchClient = $e73bf42412feb220$var$algoliasearch('5K1NL4D040', 'NTY1N2RiZjc4MWZiMzQ1MTgwZmE3MGEzODhjMTAwMDJjMmRlZDcxNTdlZWIyMjRjOThmMzc2NDIwZmYxZGJmNXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE');
const $e73bf42412feb220$var$indexName = 'cdn_public_v1_en-GB';
const $e73bf42412feb220$var$widgetsForAttributes = {
    'docno': 'menu',
    'meta.equipmenttype': 'menu',
    'meta.chaptercategory': 'refinementList',
    'format': 'menu',
    'lang': 'menu'
};
let $e73bf42412feb220$var$url = window.location.href.split('?')[0];
let $e73bf42412feb220$var$params = new URLSearchParams(window.location.search);
if (!$e73bf42412feb220$var$params.has('docno')) $e73bf42412feb220$var$params.set('docno', 'copsule');
if (!$e73bf42412feb220$var$params.has('format')) $e73bf42412feb220$var$params.set('format', 'web');
if (!$e73bf42412feb220$var$params.has('lang')) $e73bf42412feb220$var$params.set('lang', 'en-GB');
window.history.replaceState(history.state, "", $e73bf42412feb220$var$url + "?" + $e73bf42412feb220$var$params.toString());
const $e73bf42412feb220$var$search = $e73bf42412feb220$var$instantsearch({
    searchClient: $e73bf42412feb220$var$searchClient,
    indexName: $e73bf42412feb220$var$indexName,
    routing: {
        stateMapping: {
            stateToRoute (uiState) {
                const state = uiState[$e73bf42412feb220$var$indexName];
                const route = {
                    query: state.query,
                    page: state.page
                };
                [
                    'refinementList',
                    'hierarchicalMenu',
                    'menuSelect',
                    'menu'
                ].forEach((widget)=>{
                    if (state[widget]) for(var attribute in state[widget])route[attribute] = state[widget][attribute];
                });
                return route;
            },
            routeToState (routeState) {
                const state = {
                    [$e73bf42412feb220$var$indexName]: {
                        refinementList: {},
                        hierarchicalMenu: {},
                        menuSelect: {},
                        menu: {}
                    }
                };
                for(const key in routeState){
                    if (key in $e73bf42412feb220$var$widgetsForAttributes) {
                        const widget = $e73bf42412feb220$var$widgetsForAttributes[key];
                        state[$e73bf42412feb220$var$indexName][widget][key] = routeState[key];
                        continue;
                    }
                    [
                        'query',
                        'page'
                    ].forEach((attribute)=>{
                        if (key === attribute) state[$e73bf42412feb220$var$indexName][attribute] = routeState[key];
                    });
                }
                return state;
            }
        }
    }
});
function $e73bf42412feb220$var$get(fallback, obj, level, ...rest) {
    if (obj === undefined || obj === null) return fallback;
    if (rest.length === 0 && obj.hasOwnProperty(level)) {
        if (obj[level] === null && fallback !== null) return fallback;
        return obj[level];
    }
    return $e73bf42412feb220$var$get(fallback, obj[level], ...rest);
}
function $e73bf42412feb220$var$set(obj, level, ...rest) {
    if (obj === undefined || obj === null) throw Error("Invalid object supplied!");
    if (level === undefined || level === null) throw Error("At least one level must be supplied");
    if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
    if (rest.length === 1) obj[level] = rest[0];
    else $e73bf42412feb220$var$set(obj[level], ...rest);
}
// Helper: convert a label to sentence case (First letter upper, rest lower)
function $e73bf42412feb220$var$toSentenceCase(text) {
    if (text == null) return text;
    const s = String(text).trim();
    if (!s) return s;
    const lower = s.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}
function $e73bf42412feb220$var$transformItems(attributes, items) {
    if (attributes) {
        if (!Array.isArray(attributes)) attributes = [
            attributes
        ];
        // a specific attribute (facet)
        return items.map((item)=>{
            for (const attribute of attributes){
                if (attribute in transformations && item.label in transformations[attribute]) return {
                    ...item,
                    label: transformations[attribute][item.label],
                    highlighted: transformations[attribute][item.label]
                };
            }
            // Apply sentence case for specific facets if no explicit transformation matched
            if (attributes.includes('meta.equipmenttype') || attributes.includes('meta.chaptercategory')) return {
                ...item,
                label: $e73bf42412feb220$var$toSentenceCase(item.label)
            };
            return item;
        });
    } else // search results
    return items.map((item)=>{
        let result = Object.assign({}, item);
        for(let attribute in item)if (attribute in transformations && item[attribute] in transformations[attribute]) result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
        };
        else Object.keys(transformations).forEach((attribute)=>{
            let fields = attribute.split('.');
            if (fields.length > 0) {
                let value = $e73bf42412feb220$var$get(null, item, ...fields);
                if (value != null && value in transformations[attribute]) $e73bf42412feb220$var$set(result, ...fields, transformations[attribute][value]);
            }
        });
        // Ensure subtitle is sentence-cased
        if (result.titletopic != null) result.titletopic = $e73bf42412feb220$var$toSentenceCase(result.titletopic);
        return result;
    });
}
$e73bf42412feb220$var$search.addWidgets([
    $e73bf42412feb220$var$instantsearch.widgets.searchBox({
        container: '#searchbox',
        placeholder: 'Search for content'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#docno-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'docno'),
        attribute: 'docno',
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menu({
        container: '#equipmenttype-menu',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.equipmenttype'),
        attribute: 'meta.equipmenttype',
        limit: 5,
        showMore: true,
        showMoreLimit: 1000,
        cssClasses: {
            link: 'link-primary'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.refinementList({
        container: '#chapter-list',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'meta.chaptercategory'),
        attribute: 'meta.chaptercategory',
        limit: 5,
        showMore: true
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menuSelect({
        container: '#format-select',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'format'),
        attribute: 'format',
        templates: {
            defaultOption: 'Any'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.menuSelect({
        container: '#lang-select',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, 'lang'),
        attribute: 'lang',
        templates: {
            defaultOption: 'Any'
        }
    }),
    $e73bf42412feb220$var$instantsearch.widgets.pagination({
        container: '#pagination'
    }),
    $e73bf42412feb220$var$instantsearch.widgets.configure({
        attributesToSnippet: [
            'content:30'
        ],
        snippetEllipsisText: "\u2026",
        maxValuesPerFacet: 1000
    }),
    $e73bf42412feb220$var$instantsearch.widgets.hits({
        container: '#hits',
        transformItems: $e73bf42412feb220$var$transformItems.bind($e73bf42412feb220$exports, null),
        templates: {
            item: `
<article class="card">
  <div class="card-body">
    <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
    <h4 class="card-title">{{ meta.equipmenttype}}</h4>    
    <h6 class="card-subtitle mb-2">{{ titletopic }}</h6>
    </a>
    <p class="card-text">{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}</p>
    <div class="col">
        <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
        <h4 class="card-title">Read more</h4> 
        </a>
      </div>
  </div>
  <div class="card-footer">
    <div class="row justify-content-end">
      <div class="col">
        <a class="link-primary text-decoration-none" href="https://copsule.leeaint.com{{ url }}">
        <h4 class="card-title"></h4> 
        </a>
      </div>
      <div class="col-auto">
        <language-picker
          size="sm"
          lazy="true"
          class="navbar-language-picker"
          variant="lp"
          menuVariant="lp"
          docno="{{docno}}"
          default="{{lang}}"
          version="{{version}}"
          urlprefix="https://copsule.leeaint.com"
          algoliaAppId="5K1NL4D040"
          algoliaApiKey="NTY1N2RiZjc4MWZiMzQ1MTgwZmE3MGEzODhjMTAwMDJjMmRlZDcxNTdlZWIyMjRjOThmMzc2NDIwZmYxZGJmNXJlc3RyaWN0SW5kaWNlcz1jZG5fcHVibGljX3YxKiZudW1lcmljRmlsdGVycz0lNUIlNUIlMjJ2aXNpYmlsaXR5JTNFMjAwJTIyJTVEJTVE"
          algoliaIndexName="cdn_public_v1"
        ></language-picker>
      </div>
    </div>
  </div>
</article>
`
        }
    })
]);
$e73bf42412feb220$var$search.start();


//# sourceMappingURL=se.simonsoft.leea.public.ab36bf62.js.map
